module.exports = __webpack_public_path__ + "img/partner_02.3926c121.jpg";